
import React, { useState } from "react";
import {
  ReferenceInput,
  SelectInput,
  required,
  AutocompleteInput,
} from "react-admin";

import { useForm } from "react-final-form";

import { FormTextField } from "../__common/FormTextField";

export const AutoCompleteCultureCode = (props) => {
    const [reload, setReload] = useState(0);
    const form = useForm();
    const autocompletar = (value,position) => {
      const formData = form.getState().values;
      let isolateCode = formData.code ?? '';
      if(isolateCode){
        const codes = isolateCode.split('.');
        isolateCode = (position===1?codes[1]:codes[0] ) ?? '';
      }
      if((!isolateCode.includes(value)||!value)){
        form.change('code',position===1?`${value}.${isolateCode}`:`${isolateCode}.${value}`);
        setReload(p=>p+1);
      }
    }
  
    return(
          <>
            <ReferenceInput
              label="Sample"
              source="id_sample"
              reference="samples"
              validate={required()}
            >
              <AutocompleteInput
                resettable={true}
                clearAlwaysVisible={true}
                optionText="code"
                //shouldRenderSuggestions={(value) => value.trim().length > 1}
                suggestionLimit={10}
                onStateChange={(value,props)=>autocompletar(props.inputValue,1)}
              />
            </ReferenceInput>
            <ReferenceInput
              label="Culture Medium"
              source="id_culture_medium"
              reference="culture_media"
              validate={required()}
              inputProps={{
                onChange: (value,props) => {
                  autocompletar(props.props.children,2)
                }
              }}
            >
              <SelectInput 
                optionText="code" 
              />
            </ReferenceInput>
            <br></br>
            <div style={{fontSize:"0.7em", color:"gray"}}>Code culture</div>
            <FormTextField source="code" refresh={reload} ></FormTextField>
        </>
    )
  }
  